import React, { FunctionComponent, useState, useCallback } from 'react'
import { IAppShellConfiguration } from '@local/src/App.types'
import { Button, Icons } from '@trr/common-component-library'

import s from './App.module.scss'
import Menu from './Components/Menu'

const App: FunctionComponent<IAppShellConfiguration> = ({
  componentProps: { metaNavigationRoutes, navigationRoutes },
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const onMouseDown = (e: MouseEvent) => {
    //In order to prevent focus state on click, but still allow it when tabbing for accessibility
    e.preventDefault()
  }

  const showMenu = useCallback(() => {
    setIsVisible(true)
  }, [setIsVisible])

  const hideMenu = useCallback(() => {
    setIsVisible(false)
  }, [setIsVisible])

  return (
    <div data-testid="App-Main-Menu">
      <Button
        icon
        customClass={s.Button}
        onClick={showMenu}
        attributes={{ onMouseDown }}
      >
        <Icons.MenuIcon
          color={s.purple100}
          title="Meny"
          description={'Öppna meny'}
        />
      </Button>
      <Menu
        isVisible={isVisible}
        hideMenu={hideMenu}
        routes={navigationRoutes}
        metaRoutes={metaNavigationRoutes}
        testSelector={'Main-Menu'}
      />
    </div>
  )
}

export default App
